import { Link } from 'react-router-dom';
import { useSeo } from '@/hooks/useSeo';

const VALUES = [
  { icon: 'ri-compass-3-line', title: '定位清晰', desc: '只做免费优质内容聚合，不做诱导付费与捆绑推广。' },
  { icon: 'ri-hand-heart-line', title: '尊重原创', desc: '标注作者与来源，鼓励学习交流，保护创作者权益。' },
  { icon: 'ri-flashlight-line', title: '高效获取', desc: '完善的分类、搜索与筛选，让获取资源更省时间。' },
];

const TEAM = [
  { name: '内容组', role: '资源收录与审核', desc: '负责每日资源整理、分类归档与来源核实。', icon: 'ri-file-list-3-line' },
  { name: '产品组', role: '网站体验优化', desc: '打磨搜索、筛选与浏览体验，让查找更顺手。', icon: 'ri-layout-masonry-line' },
  { name: '社区组', role: '用户反馈与互动', desc: '收集用户建议，持续改进内容与功能。', icon: 'ri-chat-smile-2-line' },
];

const MILESTONES = [
  { year: '2023', text: '免费91 网站雏形上线，首批整理 50 个免费资源。' },
  { year: '2024', text: '上线视频、软件、教程三大频道，资源数突破 100。' },
  { year: '2025', text: '新增搜索筛选与收藏功能，访问量稳步增长。' },
  { year: '2026', text: '内容持续更新，致力于成为更好用的免费资源平台。' },
];

export default function AboutPage() {
  useSeo({
    title: '关于我们 - 免费91',
    description:
      '了解免费91的网站定位、发展愿景与团队，以及本站的版权与免责声明。免费91 致力于免费优质内容的聚合与分享。',
    keywords: '关于免费91,免费91介绍,免费资源平台,网站声明',
  });

  return (
    <div className="w-full">
      <section className="relative w-full overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20soft%20teal%20green%20and%20warm%20amber%20gradient%20background%20with%20smooth%20flowing%20shapes%20and%20subtle%20grain%20texture%2C%20elegant%20minimal%20editorial%20style%2C%20airy%20and%20calm%20mood%2C%20high%20detail%2C%20wide%20composition&width=1920&height=600&seq=about-hero-91&orientation=landscape"
            alt="免费91 关于我们"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/60 to-foreground-950/75"></div>
        </div>
        <div className="relative w-full px-4 md:px-8 py-16 md:py-24">
          <div className="w-full max-w-3xl">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/10 border border-background-50/20 text-background-100 text-xs md:text-sm mb-4">
              <i className="ri-information-line text-accent-400"></i>
              关于我们
            </span>
            <h1 className="font-heading font-bold text-3xl md:text-5xl text-background-50 leading-tight">
              让免费优质内容，被更容易地找到
            </h1>
            <p className="mt-4 text-background-200 text-base md:text-lg leading-relaxed">
              免费91 是一个专注于免费视频、软件与教程的资源分享平台，我们希望用清晰的分类与顺手的搜索，
              帮你在纷繁的网络内容中快速找到真正有用的那一个。
            </p>
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-8 py-14">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {VALUES.map((item) => (
            <div key={item.title} className="rounded-lg border border-background-200 bg-background-50 p-6">
              <span className="w-12 h-12 rounded-lg bg-primary-100 text-primary-700 flex items-center justify-center">
                <i className={`${item.icon} text-2xl`}></i>
              </span>
              <h2 className="mt-4 font-heading font-semibold text-lg text-foreground-950">{item.title}</h2>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="w-full bg-background-100 border-y border-background-200">
        <div className="w-full px-4 md:px-8 py-14">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
            <div>
              <h2 className="font-heading font-semibold text-2xl text-foreground-950">我们的发展愿景</h2>
              <p className="mt-4 text-foreground-600 leading-relaxed">
                我们相信，优质的免费内容值得被更多人看见。未来，免费91 会持续扩充资源库、
                优化分类与搜索体验，并尝试引入更智能的推荐方式，让每一个来到这里的用户都能有所收获。
              </p>
              <p className="mt-3 text-foreground-600 leading-relaxed">
                同时，我们也会坚持真实标注来源、尊重原创，与创作者一起维护一个健康、友好的内容环境。
              </p>
              <Link
                to="/contact"
                className="mt-6 inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-chat-3-line"></i>
                给我们留言
              </Link>
            </div>

            <div className="rounded-lg border border-background-200 bg-background-50 p-6">
              <h3 className="font-heading font-semibold text-lg text-foreground-950 mb-5">发展历程</h3>
              <ol className="relative border-l border-background-200 ml-2">
                {MILESTONES.map((item) => (
                  <li key={item.year} className="mb-6 last:mb-0 pl-6">
                    <span className="absolute -left-[7px] w-3.5 h-3.5 rounded-full bg-accent-500 border-2 border-background-50"></span>
                    <p className="font-heading font-semibold text-sm text-primary-700">{item.year}</p>
                    <p className="mt-1 text-sm text-foreground-600 leading-relaxed">{item.text}</p>
                  </li>
                ))}
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-8 py-14">
        <h2 className="font-heading font-semibold text-2xl text-foreground-950 mb-6">我们的团队</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {TEAM.map((member) => (
            <div key={member.name} className="rounded-lg border border-background-200 bg-background-50 p-6">
              <span className="w-12 h-12 rounded-full bg-secondary-100 text-secondary-700 flex items-center justify-center">
                <i className={`${member.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading font-semibold text-base text-foreground-950">{member.name}</h3>
              <p className="text-sm text-accent-700 mt-0.5">{member.role}</p>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{member.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="w-full px-4 md:px-8 pb-14">
        <div className="rounded-lg border border-background-200 bg-secondary-50 p-6 md:p-8">
          <h2 className="font-heading font-semibold text-xl text-foreground-950 mb-4">
            <i className="ri-copyright-line mr-2 text-secondary-700"></i>
            版权及免责声明
          </h2>
          <div className="space-y-3 text-sm text-foreground-600 leading-relaxed">
            <p>
              1. 本站所有资源信息均由网络公开渠道收集整理或由作者授权分享，仅用于学习、研究与交流，本站不存储任何资源文件。
            </p>
            <p>
              2. 本站标注的作者、来源等信息仅供参考，若权利人认为内容侵犯其合法权益，请通过
              <Link to="/contact" className="text-primary-700 hover:text-primary-800 mx-1">联系我们</Link>
              页面反馈，我们将及时核实并处理。
            </p>
            <p>
              3. 用户因使用本站内容而产生的任何后果由用户自行承担，本站不对资源的可用性、准确性作出担保。
            </p>
            <p>
              4. 本站为演示性质的内容平台，页面中的播放器、软件下载等均为展示用途，不提供真实文件下载与视频播放。
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}